import React, { useState, useEffect } from 'react';
import { Container, List, ListItem, ListItemText, Typography } from '@mui/material';
import { fetchVariableValues } from './Extractor';

const VariableValues = ({}) => {
  const [values, setValues] = useState([]);
  const [error, setError] = useState(null);

  const variableName='Type Social Media';

  useEffect(() => {
    const getValues = async () => {
      const { values, error } = await fetchVariableValues(variableName);
      setValues(values);
      setError(error);
    };

    getValues();
  }, [variableName]);

  return (
    <Container>
      <Typography variant="h4">Values for {variableName}</Typography>
      {error ? (
        <Typography color="error">{error}</Typography>
      ) : (
        <List>
          {values.map((value, index) => (
            <ListItem key={index}>
              <ListItemText primary={value} />
            </ListItem>
          ))}
        </List>
      )}
    </Container>
  );
};

export default VariableValues;
